<p-dialog
  [(visible)]="display"
  [style]="{ width: '40vw' }"
  (onHide)="cancel()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <b>{{rejectQuarantinedDocumentHeader}}</b>
  </ng-template>
  <p>
    {{requiredModalHeader}}
  </p>

  <div class="field field-required">
    <bpt-text-input      
      [highlightAllOnFocus]="true"
      placeholder="Enter the Reason"
      [multiLine]="true"
      id="reasonForRejectionDescription"
      label="Reason For Rejection*"
      [(ngModel)]="reasonForRejection"
      (ngModelChange)="onReasonForRejectionChange()"
    ></bpt-text-input>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      appPreventDoubleClick
      label="Reject"
      type="submit"
      id="rejectQuarantineDocumentButton"
      (debounceClick)="rejectQuarantineDocuments()"
      [disabled]="!isRejectEnabled"
    >
    </p-button>
    <p-button 
    appPreventDoubleClick 
    styleClass="p-button-outlined" 
    label="Cancel" 
    id="cancel" 
    (debounceClick)="cancel()"></p-button>
  </ng-template>
</p-dialog>
